import React from 'react';
import { IMAGES, stats, testimonials } from '../data/breakFreeContent';
type TestimonialsSectionProps = {
  /** The first appearance carries the statistics and the aspirational visual. */
  variant?: 'primary' | 'compact';
  id?: string;
};
export function TestimonialsSection({
  variant = 'primary',
  id = 'proof'
}: TestimonialsSectionProps) {
  const isPrimary = variant === 'primary';
  return <section className={`w-full py-12 sm:py-16 ${isPrimary ? 'bg-charcoal-900' : 'bg-charcoal-900'}`} aria-labelledby={`${id}-title`} data-id="element-164" data-mp="1d1l7yn73yywq">
      <div className="mx-auto max-w-6xl px-5" data-id="element-165" data-mp="141690l181lar">
        <h2 id={`${id}-title`} className="sr-only" data-id="element-166" data-mp="142hohi414hhp">
          What women are saying
        </h2>

        {isPrimary && <dl className="grid grid-cols-2 gap-y-6 border-b border-charcoal-600 pb-10 sm:grid-cols-4" data-id="element-167" data-mp="1831jog51lb17">
            {stats.map(s => <div key={s.label} className="text-center" data-id="element-168" data-mp="32gj0lkaxz9n9">
                <dd className="font-display text-2xl font-semibold text-champagne sm:text-3xl" data-id="element-169" data-mp="32fzsevb3fzmf">
                  {s.value}
                </dd>
                <dt className="mx-auto mt-1 max-w-[8rem] text-[9px] font-medium uppercase tracking-[0.16em] text-muted sm:text-[10px]" data-id="element-170" data-mp="2q2rfgz3taox6">
                  {s.label}
                </dt>
              </div>)}
          </dl>}

        <div className={isPrimary ? 'mt-10 grid gap-6 lg:grid-cols-[0.75fr_1.25fr] lg:items-center lg:gap-10' : ''} data-id="element-171" data-mp="2zst2dnkfi1ai">
          {isPrimary && <img src={IMAGES.autonomy} alt="The BREAK FREE™ transformation — from uncertainty to a confident, independent life" className="h-52 w-full object-contain sm:h-64 lg:h-[20rem]" width={1200} height={900} data-id="element-172" data-mp="275q5t0zbc0mw" />}

          <ul className="grid gap-3 sm:grid-cols-3" data-id="element-173" data-mp="1ci33hemhxht">
            {testimonials.map(t => <li key={t.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800 p-4" data-id="element-174" data-mp="3sj2oakhzyb6x">
                <span className="text-[10px] tracking-[0.2em] text-champagne" aria-label="5 out of 5 stars" data-id="element-175" data-mp="8cu0odiuwqw8">
                  ★★★★★
                </span>
                <blockquote className="mt-2.5 text-[13px] leading-relaxed text-ivory-100" data-id="element-176" data-mp="iaqan2025fsr">
                  “{t.quote}”
                </blockquote>
                <footer className="mt-auto pt-3 text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-177" data-mp="3lsropsw4bmrd">
                  {t.name} · {t.location}
                  <span className="ml-2 text-rose" data-id="element-178" data-mp="3qr30wa9vy9cr">{t.day}</span>
                </footer>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}